var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5007 33.0005C30.9919 33.0005 32.2007 31.7917 32.2007 30.3005C32.2007 28.8093 30.9919 27.6006 29.5007 27.6006C28.0095 27.6006 26.8008 28.8093 26.8008 30.3005C26.8008 31.7917 28.0095 33.0005 29.5007 33.0005Z",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5007 20.3999C30.9919 20.3999 32.2007 19.1911 32.2007 17.6999C32.2007 16.2088 30.9919 15 29.5007 15C28.0095 15 26.8008 16.2088 26.8008 17.6999C26.8008 19.1911 28.0095 20.3999 29.5007 20.3999Z",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6999 26.6994C20.1911 26.6994 21.3999 25.4907 21.3999 23.9995C21.3999 22.5083 20.1911 21.2996 18.6999 21.2996C17.2088 21.2996 16 22.5083 16 23.9995C16 25.4907 17.2088 26.6994 18.6999 26.6994Z",
    stroke: "#262121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2491 19.0498L20.9492 22.6497",
    stroke: "#262121",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9492 25.3494L27.2491 28.9493",
    stroke: "#262121",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.08c5989497ba5c5f214cbdd69b5f3ce7.svg";
export { ForwardRef as ReactComponent };